(function () {
    function closeMenu(item) {
        var toggle = item.querySelector('.nav-organisationen-toggle');
        item.classList.remove('is-open');
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        }
    }

    function closeAllMenus(except) {
        document.querySelectorAll('.nav-organisationen.is-open').forEach(function (item) {
            if (item !== except) {
                closeMenu(item);
            }
        });
    }

    document.addEventListener('click', function (event) {
        var toggle = event.target.closest('.nav-organisationen-toggle');

        if (toggle) {
            var item = toggle.closest('.nav-organisationen');
            var willOpen = !item.classList.contains('is-open');
            closeAllMenus(item);
            item.classList.toggle('is-open', willOpen);
            toggle.setAttribute('aria-expanded', String(willOpen));
            return;
        }

        if (!event.target.closest('.nav-organisationen')) {
            closeAllMenus();
        }
    });

    document.addEventListener('keydown', function (event) {
        var toggle = event.target.closest('.nav-organisationen-toggle');

        if (toggle && event.key === 'ArrowDown') {
            event.preventDefault();
            var item = toggle.closest('.nav-organisationen');
            closeAllMenus(item);
            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            var firstLink = item.querySelector('.nav-organisationen-flyout a');
            if (firstLink) {
                firstLink.focus();
            }
            return;
        }

        if (event.key === 'Escape') {
            var openItem = event.target.closest('.nav-organisationen.is-open');
            if (openItem) {
                event.preventDefault();
                var openToggle = openItem.querySelector('.nav-organisationen-toggle');
                closeMenu(openItem);
                if (openToggle) {
                    openToggle.focus();
                }
            }
        }
    });
})();
